const errmsg = state => {
    return (state && state.errmsg) || ''
}

const advertiseList = state => {
    return (state && state.advertiseList) || {}
}

const loadingAL = state => {
    return (state && state.loadingAL) || ''
}

const productList = state => {
    return (state && state.productList) || {}
}

const loadingPL = state => {
    return (state && state.loadingPL) || ''
}

const product = state => {
    return (state && state.product) || {}
}

const loadingPro = state => {
    return (state && state.loadingPro) || ''
}

const incomeDetail = state => {
    return (state && state.incomeDetail) || {}
}

const loadingID = state => {
    return (state && state.loadingID) || ''
}

const uBalance = state => {
    return (state && state.uBalance) || {}
}

const loadingUB = state => {
    return (state && state.loadingUB) || ''
}

const payList = state => {
    return (state && state.payList) || {}
}

const paying = state => {
    return (state && state.paying) || ''
}

const purchaseHiList = state => {
    return (state && state.purchaseHiList) || {}
}

const purchasing = state => {
    return (state && state.purchasing) || ''
}

export default {
    errmsg,
    advertiseList,
    loadingAL,
    productList,
    loadingPL,
    product,
    loadingPro,
    incomeDetail,
    loadingID,
    uBalance,
    loadingUB,
    payList,
    paying,
    purchaseHiList,
    purchasing
}